import { render } from "./NewOrderPage.vue?vue&type=template&id=11aacf46&ts=true"
import script from "./NewOrderPage.vue?vue&type=script&lang=ts"
export * from "./NewOrderPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__